/**
 * 操作审计的数据请求（TanStack Query），接口与参数与旧版 AuditLogsView.vue 一致
 */
import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { adminApi, type AuditLogParams } from '@/api/services/admin'

const AUDIT_KEY = ['admin', 'audit-logs'] as const

export interface AuditLog {
  id: number
  admin_id: number | null
  admin_username: string | null
  admin_name: string | null
  action: string
  target_type: string | null
  target_id: string | number | null
  old_values: unknown
  new_values: unknown
  details: unknown
  ip_address: string | null
  user_agent: string | null
  success: boolean
  error_message: string | null
  created_at: string
}

export interface AuditStats {
  total_logs: number
  success_count: number
  failed_count: number
  admin_count: number
}

const EMPTY_STATS: AuditStats = { total_logs: 0, success_count: 0, failed_count: 0, admin_count: 0 }

export function useAuditLogs(params: AuditLogParams) {
  return useQuery({
    queryKey: [...AUDIT_KEY, 'list', params],
    queryFn: async () => {
      const response = await adminApi.getAuditLogs(params)
      const result = response.data.data ?? {}
      return {
        logs: (result.logs ?? []) as AuditLog[],
        total: (result.pagination?.total ?? 0) as number,
        stats: { ...EMPTY_STATS, ...result.stats } as AuditStats
      }
    },
    placeholderData: keepPreviousData
  })
}

// 筛选下拉的选项；加载失败时为空，不影响列表
export function useAuditActionOptions() {
  return useQuery({
    queryKey: [...AUDIT_KEY, 'actions'],
    queryFn: async () => ((await adminApi.getAuditLogActions()).data.data?.actions ?? []) as string[]
  })
}

export function useAuditTargetTypeOptions() {
  return useQuery({
    queryKey: [...AUDIT_KEY, 'target-types'],
    queryFn: async () => ((await adminApi.getAuditLogTargetTypes()).data.data?.target_types ?? []) as string[]
  })
}
